module.exports = __webpack_public_path__ + "img/article-icon-105.75d2b429.svg";